import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { MipAnalysisListScreen } from "./MipAnalysisListScreen";
import { MipSessionsListScreen } from "./MipSessionsListScreen";
import { MipAnalysisScreen } from "./MipAnalysisScreen";
import { PrivateRoute } from "../../../Core/PrivateRoute";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";

export const MipRoot = () => {
    return (
        <Routes>
            <Route index
                element={
               <PrivateRoute permissions={[PermissionEnum.AccessSingleMipSession, PermissionEnum.AccessAllMipSessions, PermissionEnum.OverreadMipSession]}>
                <MipSessionsListScreen />
                    </PrivateRoute>
                }
            />
            <Route path="Analysis" element={
               <PrivateRoute permissions={[PermissionEnum.OverreadMipSession]}>
                <MipAnalysisListScreen />
                </PrivateRoute>
            }
            />
            <Route path="Analysis/:analysisSetId/:viewState" element={
                <PrivateRoute permissions={[PermissionEnum.OverreadMipSession, PermissionEnum.AccessSingleMipSession]}>
                <MipAnalysisScreen />
                </PrivateRoute>
            }
            />
        </Routes>
    );
}
